<div class="productReassurance">
  <vc-accordion>
    <vc-accordion-group
      *ngIf="!directShippingEligible"
      [isOpen]="false"
      [index]="1"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === 1"
      class="productReassurance__item"
    >
      <div
        class="accordion__title productReassurance__item__title vc-body"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.QUALITY_TITLE"
      >
        Quality control
      </div>
      <div
        class="accordion__content productReassurance__item__content productReassurance__item__content--quality vc-body3"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.QUALITY"
      >
        <p class="quality__p">100% of sold items are checked by our experts.</p>
        <p>Before sending you your new purchase, our dedicated team verifies:</p>
        <ul>
          <li>- authenticity and quality standards</li>
          <li>- conformity with the seller's description</li>
          <li>- the condition mentioned by the seller</li>
        </ul>
        <p class="quality__p">A real reliable guarantee for all our customers!</p>
        <p class="quality__p">
          Vestiaire Collective has no association and/or affiliation with the brands whose products areoffered for sale
          on its website/App.
        </p>
        <p class="quality__p">
          The authentication of said products is performed independently by Vestiaire Collective.
        </p>
      </div>
    </vc-accordion-group>
    <vc-accordion-group
      [isOpen]="false"
      [index]="2"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === 2"
      headingArrowPosition=""
      headingArrowColor=""
      class="productReassurance__item"
    >
      <div
        class="accordion__title productReassurance__item__title vc-body"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.PAYMENT_TITLE"
      >
        Payment
      </div>
      <div
        class="accordion__content  productReassurance__item__content productReassurance__item__content--payment vc-body3"
      >
        <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.PAYMENT">100% SECURED PAYMENT</p>
        <div class="productReassurance__payment__icons">
          <ng-container *ngFor="let method of paymentMethod">
            <vc-svg-cart-payment [payment]="method.mnemonic"></vc-svg-cart-payment>
          </ng-container>
        </div>
      </div>
    </vc-accordion-group>
    <vc-accordion-group
      *ngIf="shipping"
      [isOpen]="false"
      [index]="3"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === 3"
      class="productReassurance__item"
    >
      <div
        class="accordion__title productReassurance__item__title vc-body"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.EXPEDITION_TITLE"
      >
        Shipping
      </div>
      <div
        class="accordion__content  productReassurance__item__content productReassurance__item__content--expedition vc-body3"
      >
        <p *ngIf="!product.inStock" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.EXPEDITION_1">
          The article is currently with the seller. Once the item has been purchased, the seller will receive a shipping
          label to send the item to Vestiaire Collective so it can be checked by our quality experts in
          {{ shipping.warehouse.localizedName }}.
        </p>
        <p *ngIf="product.inStock" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.EXPEDITION_IN_STOCK">
          The item is currently at Vestiaire Collective in {{ shipping.warehouse.localizedName }} and has successfully
          passed quality control by our team of experts. Delivery time is estimated at {{ shipping.sendDelay }} day(s)
          subject to carrier delivery time.
        </p>
        <ng-container *ngIf="showNewShippingFees; else oldShippingFees">
          <p
            *ngIf="shippingFeesLowAmount !== shippingFeesHighAmount; else uniquePrice"
            i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.SHIPPING_FEES"
          >
            The shipping cost for this product may vary from {{ shippingFeesLowAmount }} to
            {{ shippingFeesHighAmount }}. We invite you to visit our Terms of Use to check the fee schedule of shipping
            costs.
          </p>
          <ng-template #uniquePrice>
            <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.SHIPPING_FEES_UNIQUE">
              The shipping cost for this product is {{ shippingFeesLowAmount }}. We invite you to visit our Terms of Use
              to check the fee schedule of shipping costs.
            </p>
          </ng-template>
        </ng-container>
        <ng-template #oldShippingFees>
          <div class="productReassurance__expedition__table">
            <div class="productReassurance__expedition__row">
              <div class="productReassurance__expedition__cell" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.DESTINATION_TO">
                To:
              </div>
              <div class="productReassurance__expedition__cell">{{ shipping?.destinationCountry?.localizedName }}</div>
            </div>
            <div class="productReassurance__expedition__row">
              <div class="productReassurance__expedition__cell">
                <ng-container i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.PRICE_MIN">Low price:</ng-container>
                {{ shipping?.cost?.lowValue?.formatted }}
              </div>
              <div class="productReassurance__expedition__cell">{{ shipping?.cost?.lowAmount?.formatted }}</div>
            </div>
            <div class="productReassurance__expedition__row">
              <div class="productReassurance__expedition__cell">
                <ng-container i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.PRICE_MAX">High price:</ng-container>
                {{ shipping?.cost?.highValue?.formatted }}
              </div>
              <div class="productReassurance__expedition__cell">{{ shipping?.cost?.highAmount?.formatted }}</div>
            </div>
          </div>
          <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.EXPEDITION_2">
            The shipping cost is valid for the total value of your order. Please consult the Terms of Use for shipping
            cost details.
          </p>
        </ng-template>
      </div>
    </vc-accordion-group>
    <vc-accordion-group
      [isOpen]="false"
      [index]="4"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === 4"
      class="productReassurance__item"
    >
      <div
        class="accordion__title productReassurance__item__title vc-body"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_TITLE"
      >
        Returns
      </div>
      <div
        class="accordion__content  productReassurance__item__content productReassurance__item__content--returns vc-body3"
      >
        <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_1">Please note that in accordance with our Terms of Use:</p>
        <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_PARTICULAR">
          - Items purchased from an individual seller are neither refundable nor exchangeable. If your item does not
          suit you, we offer you the possibility to resell the item without commission. The item will be relisted at the
          purchase price and only a handling fee will be deducted.
        </p>
        <!--
          <button class="productReassurance__returns__link" (click)="openModalReturnsParticular()" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_KNOW_MORE">Read more</button>
        -->
        <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_PRO">
          - Items purchased from a professional seller are eligible for return.
        </p>
        <!--
          <button class="productReassurance__returns__link" (click)="openModalReturnsPro()" i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.RETURNS_KNOW_MORE">Read more</button>
        -->
      </div>
    </vc-accordion-group>
    <vc-accordion-group
      [isOpen]="false"
      [index]="5"
      (change)="toggleAccordionClass($event)"
      [class.open]="modifierClass === 5"
      class="productReassurance__item"
    >
      <div
        class="accordion__title productReassurance__item__title vc-body"
        i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.HELP_TITLE"
      >
        Help
      </div>
      <div
        class="accordion__content  productReassurance__item__content productReassurance__item__content--help vc-body3"
      >
        <div class="productReassurance__help">
          <img class="productReassurance__help__icon" src="/assets/svg/question.svg" alt="" />
          <vc-ref
            i18n-resource="@@LINKS.DESCRIPTION.REASSURANCE.HELP_QUESTION"
            resource="https://faq.vestiairecollective.com/hc/en-us"
            [blank]="true"
          >
            <p i18n="@@PRODUCT.DESCRIPTION.REASSURANCE.HELP_QUESTION">FAQ & Customer Care</p>
          </vc-ref>
        </div>
      </div>
    </vc-accordion-group>
  </vc-accordion>
</div>
